import React, { useEffect, useState } from 'react'
import SupplyBillItem from './SupplyBillItem'
import { checkValid, updateValidate, updateValueObjInArrayForm } from '../../../../../../../../../helpers/form/FormHelper'
import { useSelector } from 'react-redux'

const SupplyBillItems = ({ supplyOrderItems, checked, setValueForm, setValidate, forciblyValue }) => {

    const supplyOrder = useSelector(state => state.supplyOrder.supplyOrder)
    
    const [data, setData] = useState([]) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
    // console.log('valid', valid)
	const [loading, setLoading] = useState(false)

	// const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setValidate)
	}, [valid])

	useEffect(() => {
		if (data) {
			// setValueFormItem(data)
			setValueForm(data)
		}
	}, [data])

  return (
    <>
        {
            checked && Object.keys(checked).length > 0 ?
                // supplyOrderItems && supplyOrderItems.length > 0 ?
                //     supplyOrderItems.map(item => {
                supplyOrder.items && supplyOrder.items.length > 0 ?
                    supplyOrder.items.map(item => {
                        if (checked[item.id]) {
                            return (
                                <SupplyBillItem 
                                    key={item.id}
                                    item={item}
                                    setValidate={e => updateValidate(setValid, item.id, e)}
                                    setValueFormItem={e => updateValueObjInArrayForm(setData, item.id, e)}
                                />
                            )
                        }
                    })
                : ''
            : ''
        }
    </>
  )
}

export default SupplyBillItems